<div fxLayout="column">
  <mat-chip-grid #cptChipGrid fxFlex>
    <mat-chip
      *ngFor="let product of value; index as i"
      [value]="product"
      selectable
      removable
      (removed)="removeSelectedCode(i)"
      fxLayoutAlign="space-between center"
    >
      {{ getItemLabel(product) }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    <input
      matInput
      fxFlex
      #selectCptInput
      [formControl]="productsCtrl"
      [matAutocomplete]="productsAutocomplete"
      [matChipInputFor]="cptChipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      id="input-chip-list"
    />
  </mat-chip-grid>
  <mat-autocomplete
    fxFlex
    #productsAutocomplete="matAutocomplete"
    (optionSelected)="selected($event)"
    panelWidth="550px"
  >
    <mat-option *ngIf="selectAllOption" (click)="selectAll()">Select All</mat-option>
    <mat-option
      *ngFor="let product of filteredProducts | async"
      [value]="product"
    >
      <span *ngIf="product.sku">[{{ product.sku }}]</span>
      <span *ngIf="!product.sku && !!product.getCPTCodes">[{{ product.getCPTCodes() | join }}]</span>
      {{ getItemLabel(product) }}
    </mat-option>
  </mat-autocomplete>

  <div
    *ngIf="value && value.length > 1"
    class="mt-4"
    fxLayout="row"
    fxLayoutAlign="start end"
  >
    <button
      mat-flat-button
      type="button"
      class="btn-sm"
      (click)="removeSelectedCode()"
    >
      {{ 'common.remove-all' | translate }}
    </button>
    <button
      mat-flat-button
      type="button"
      class="btn-sm"
      (click)="copySelectedValue()"
    >
      {{ 'common.copy' | translate }}
    </button>
  </div>
</div>
